import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BannersService } from '../banners.service';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as BannersActions from './banners.actions';

@Injectable()
export class BannersEffects {
    constructor(
        private actions$: Actions,
        private bannersService: BannersService
    ) {}

    getBanners$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BannersActions.getBanners),
            mergeMap(() =>
                this.bannersService.getBanners().pipe(
                    map(({ messages }) => {
                        return BannersActions.getBannersSuccess({ banners: messages });
                    }),
                    catchError((err) => {
                        console.warn('Banners error: ', err);
                        return throwError(err);
                    })
                )
            )
        );
    });
}
